import segmentWrapper from '@/shared/tracking/segment-wrapper.js'
import auth from '@/shared/auth'
import { initOneTrustFlowWithInjection } from '@ui/one-trust/dist/consent-wiring'
import cookies from '@/shared/cookies'

export default async function () {
  const { segmentWriteKey } = window.siteInfo

  if (segmentWriteKey) {
    // The useOneTrust value is unique to the locale, hence we don't need to check brand.
    if (window.siteInfo.useOneTrust) {
      // initialize segment, but prevent it from loading
      segmentWrapper.init(segmentWriteKey, true)
      // Placeholder for script injection of onetrust here
      initOneTrustFlowWithInjection({ sdkKey: window.siteInfo?.oneTrustSettings?.domainId, segmentWriteKey: segmentWriteKey })
    } else {
      segmentWrapper.init(segmentWriteKey)
    }
    // Identify the user if logged in
    if (auth.isLoggedIn()) {
      segmentWrapper.identify(auth.userData().id)
    }
  } else if (window.newrelic) {
    window.newrelic.noticeError(new Error('segment writekey unavailable'))
  }

  // in case of a SiteSpect experiment and if the signaling cookie is set
  // get the value of the cookie and parse it to get access to the campaign and variations
  // if there is an active campaign and variation (none of them is zero) track the "Experiment Viewed" event
  // with the corresponding data
  const campaignDataCookie = cookies.get('SSEV')
  if (campaignDataCookie) {
    const campaigns = campaignDataCookie?.split(',') || []
    campaigns.forEach((campaign) => {
      const [campaignId, variationId] = campaign.split('_')
      if (Number(campaignId) !== 0 && Number(variationId) !== 0) {
        segmentWrapper.track('Experiment Viewed', {
          experimentName: `SiteSpect campaign #${campaignId}`,
          variationName: `SiteSpect variation #${variationId}`,
          campaignId,
          variationId
        })
      }
    })
  }

  /* We want to set feature flags as new relic custom attribute so that
  we can filter errors by feature flags when rolling out.
  If user in multiple experiments, flags are separated by ':' in the cookie */
  const featureFlags = cookies.get('hb_feature_flags')
  if (featureFlags) {
    // eslint-disable-next-line no-unused-expressions
    window.newrelic?.setCustomAttribute?.('hb_feature_flags', featureFlags)
  }
}
